import React from 'react'
import ReactDOM from 'react-dom/client'
import App from '@/App.jsx'
import '@/index.css'

// Temporary cleanup for local storage mock data (Disabled to allow data persistence on refresh)
// Object.keys(localStorage).forEach(key => {
//   if (key.startsWith('mock_')) localStorage.removeItem(key);
// });
// localStorage.removeItem('satala_client_pos');

ReactDOM.createRoot(document.getElementById('root')).render(
  <App />
)
